import { Container } from '@material-ui/core';
import styled from 'styled-components';

export const StyledContainer = styled((props) => <Container {...props} />)`
  background-color: white;
  padding-top: 20px;
  padding-bottom: 20px;
`;
